import { useNavigate } from "react-router-dom";
import { useOrganizations } from "../shared/hooks/evals"

/**
 * View all organizations with their details.
 **/
export default function ViewOrganizations({ user }) {
  const organizations = useOrganizations();
  const nav = useNavigate();

  if (organizations === null) {
    return <p>Loading...</p>
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">Organizations</h1>
          <p className="mt-2 text-sm text-gray-700">
            All organization customers of Hemispheres Neuro.
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
          <button
            type="button"
            className="block rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            onClick={() => nav("/create_organization")}
          >
            Create Organization
          </button>
        </div>
      </div>
      <div className="mt-8 flow-root">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                    Name
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Type
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Email
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Phone
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                    Address
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                    <span className="sr-only">Actions</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {organizations.map((org) => {
                  const orgType = org.type === "coachfax" ? "coachfax" : "vasi";
                  const orgName = org.name || org.company_name || "Unnamed Organization";
                  return (
                    <tr key={org.id}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        {orgName}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ${
                          orgType === "vasi"
                            ? 'bg-blue-50 text-blue-700 ring-1 ring-inset ring-blue-700/10'
                            : 'bg-green-50 text-green-700 ring-1 ring-inset ring-green-700/10'
                        }`}>
                          {orgType.toUpperCase()}
                        </span>
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{org.email || "—"}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{org.phone || "—"}</td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{org.address || "—"}</td>
                      <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                        <div className="flex justify-end gap-4">
                          <button
                            onClick={() => nav(`/edit_organization/${org.id}`)}
                            className="text-indigo-600 hover:text-indigo-900"
                          >
                            Edit<span className="sr-only">, {orgName}</span>
                          </button>
                          {orgType === "vasi" ? (
                            <>
                              <button
                                onClick={() => nav(`/organization/${org.id}/staff`)}
                                className="text-indigo-600 hover:text-indigo-900"
                              >
                                View Staff
                              </button>
                              <button
                                onClick={() => nav(`/organization/${org.id}/clients`)}
                                className="text-indigo-600 hover:text-indigo-900"
                              >
                                View Clients
                              </button>
                            </>
                          ) : (
                            <button
                              onClick={() => nav(`/organization/${org.id}/staff`)}
                              className="text-indigo-600 hover:text-indigo-900"
                            >
                              View Users
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
